import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function HealthPage() {
    const [governmentServicesArray, setGovernmentServicesArray] = useState<Service[]>([]);
    const [europeanServicesArray, setEuropeanServicesArray] = useState<Service[]>([]);
    const [internationalServicesArray, setInternationalServicesArray] = useState<Service[]>([]);
    const [ngoServicesArray, setNgoServicesArray] = useState<Service[]>([]);

    const getGovernmentServices = () =>
        servicesData.filter((srv: Service) => srv.category === "ΥγειοΚυβερνητικοί Οργανισμοί");

    const getEuropeanServices = () =>
        servicesData.filter((srv: Service) => srv.category === "ΥγειοΕυρωπαϊκοί Οργανισμοί");

    const getInternationalServices = () =>
        servicesData.filter((srv: Service) => srv.category === "ΥγειοΔιεθνείς Οργανισμοί");

    const getNgoServices = () =>
        servicesData.filter((srv: Service) => srv.category === "ΥγειοΜη Κυβερνητικοί Οργανισμοί");

    useEffect(() => {
        const governmentServicesList = getGovernmentServices();
        setGovernmentServicesArray(governmentServicesList);
    }, []);

    useEffect(() => {
        const europeanServicesList = getEuropeanServices();
        setEuropeanServicesArray(europeanServicesList);
    }, []);

    useEffect(() => {
        const internationalServicesList = getInternationalServices();
        setInternationalServicesArray(internationalServicesList);
    }, []);

    useEffect(() => {
        const ngoServicesList = getNgoServices();
        setNgoServicesArray(ngoServicesList);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={useColorModeValue("primary", "light")}>
                <TabList flex="1">
                    <Tab style={{ fontWeight: 'bold' }}>Κυβερνητικοί οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Ευρωπαϊκοί οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Διεθνείς Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Μη Κυβερνητικοί Οργανισμοί</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {governmentServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {europeanServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {internationalServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {ngoServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}
